import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Switch } from "../ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";

const clauseCategories = [
  "Confidentiality", "Liability", "Termination", "Indemnity",
  "Intellectual Property", "Force Majeure", "Dispute Resolution",
  "Non-Compete", "Warranty", "Payment Terms", "Data Protection",
  "Compliance", "General",
];

export function ClauseEditorDialog({ open, onOpenChange, selectedClause, formData, setFormData, onSave, saving }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{selectedClause ? "Edit Clause" : "Create Clause"}</DialogTitle>
          <DialogDescription>{selectedClause ? "Update the clause details below" : "Create a new pre-approved clause"}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Clause Name *</Label>
              <Input value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} placeholder="e.g., Standard Confidentiality" className="rounded-sm" data-testid="clause-name-input" />
            </div>
            <div className="space-y-2">
              <Label>Category *</Label>
              <Select value={formData.category} onValueChange={(value) => setFormData({ ...formData, category: value })}>
                <SelectTrigger className="rounded-sm" data-testid="clause-category-select"><SelectValue placeholder="Select category" /></SelectTrigger>
                <SelectContent>{clauseCategories.map((cat) => <SelectItem key={cat} value={cat}>{cat}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          </div>
          <div className="space-y-2">
            <Label>Description</Label>
            <Input value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} placeholder="Brief description of when to use this clause" className="rounded-sm" data-testid="clause-description-input" />
          </div>
          <div className="space-y-2">
            <Label>Clause Content *</Label>
            <Textarea value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })} placeholder="Enter the clause text..." rows={8} className="rounded-sm" data-testid="clause-content-input" />
          </div>
          <div className="flex items-center justify-between p-4 border rounded-sm">
            <div>
              <Label className="text-base">Mandatory Clause</Label>
              <p className="text-sm text-slate-500">Mark this clause as required for certain contract types</p>
            </div>
            <Switch checked={formData.is_mandatory} onCheckedChange={(checked) => setFormData({ ...formData, is_mandatory: checked })} data-testid="clause-mandatory-switch" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Cancel</Button>
          <Button onClick={onSave} disabled={saving} className="rounded-sm" data-testid="save-clause-btn">
            {saving && <Loader2 size={16} className="animate-spin mr-2" />}
            {selectedClause ? "Update Clause" : "Create Clause"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { clauseCategories };
